import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

  const routes = [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta:{
        title: '合同'
      }
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      meta:{
        title: '合同'
      }
    }
]

const router = new VueRouter({
  mode: 'history',
  routes
})


export default router
